import { Component, OnInit, HostListener } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfirmDialogModel, ConfirmationDialogComponent } from 'src/app/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material';
@Component({
  selector: 'app-error-log',
  templateUrl: './error-log.component.html',
  styleUrls: ['./error-log.component.scss']
})
export class ErrorLogComponent implements OnInit {
  @HostListener('getAllDevices')

  private ResponseVerifiedGetAllDevices$: Subject<any> = new Subject();
  private ResponseVerifiedChangeDeviceStatus$: Subject<any> = new Subject();


  key: any;
  devices: any = [];
  dataObject: any = {};
  role: any;
  page: any = 1;
  roleName: string;
  search: any = '';
  limit: any = 10;
  offset: any = 0;
  srcString: any = '';
  editDeviceResquestObject: any = {};
  count: any;
  SadminAccess: any = [];
  access: any;

  constructor(private router: Router, private dialog: MatDialog, private route: ActivatedRoute, private dashboardService: DashboardService, private toastr: ToastrService) {
    this.role = localStorage.role;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    } else if (this.role == '5') {
      this.roleName = 'slave_admin';
    }
  }

  ngOnInit() {
    this.SadminAccess = JSON.parse(localStorage.getItem('SadminAccess') || '[]');

    if (localStorage.SadminAccess != undefined) {
      this.SadminAccess.forEach(x => {
        if (x.menu_name == 'Device Inventory') {
          this.access = x.access
        }
      })
    }
    if (this.roleName == 'admin' || this.roleName == 'slave_admin') {
      this.getAllDevices(this.search, 0);
    }

  }
  editNormalUser(error_no) {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        'error_no': error_no,
      }
    };
    this.router.navigate(['/inject-solar/add-error-log/'], navigationExtras)
  }
  deleteNormalUser(error_no){

    var deletenormluserObj={
      error_no:error_no,
    }
        this.dashboardService.deleteErrorById(deletenormluserObj)
          .pipe()
          .subscribe(
            async data => {
              if (data.status) {
                this.toastr.success(data.message);
                this.getAllDevices(this.search,this.offset);

              } else if (!data.status) {
                if (data.message == 'Unauthorised or Login Time-out') {
                  this.toastr.info(data.message);
                  this.router.navigate(["/login"]);

                } else {
                  this.toastr.info(data.message);

                }

              }
            },
            err => {
              return console.error(err);
            }
          );

  }
  // get All Devices For admin User
  getAllDevices(search, offset): void {
    {
    if (offset == 0) {
      this.page = 1;
    }
    this.dataObject = {
      search: search,
      limit: this.limit,
      offset: offset
    }
    this.dashboardService.getAllErrorCode(this.dataObject)
      .pipe(takeUntil(this.ResponseVerifiedGetAllDevices$))
      .subscribe(
        async data => {
          this.count = 0;
          this.devices = [];
          if (data.status) {
            this.count =  data.count;
            this.devices = data.resultObject;

          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // editDevice(deviceId) {
  //   let navigationExtras: NavigationExtras = {
  //     queryParams: {
  //       'device_id': deviceId,
  //     }

  //   };
  //   this.router.navigate(['/inject-solar/add-device/'], navigationExtras);
  // }
  }
  nextPageNew(pageIndex): void {
    this.offset = (pageIndex - 1) * 10;
    this.getAllDevices(this.srcString, this.offset);
  }

  public confirmDialog(device_id: any): void {
    let message = "Are you sure you want to delete this Device?";
    let title = "Confirm Action";
    const dialogData = new ConfirmDialogModel(title, message);
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
         this.deleteDeviceById(device_id);
      }
    });
  }
  deleteDeviceById(device_id): void {

    var dataObject = {
      device_id: device_id,

    }
    this.dashboardService.deleteDeviceBuId(dataObject)
      .pipe(takeUntil(this.ResponseVerifiedGetAllDevices$))
      .subscribe(
        async data => {
          if (data.status) {
            // this.count = data.count;
            // this.devices = data.resultObject;
            this.toastr.success(data.message);
            this.getAllDevices(this.search, this.offset);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  //change device status
  changeDeviceStatus(deviceId, deviceStatus, index) {


    this.editDeviceResquestObject = {
      device_id: deviceId
    };
    this.dashboardService
      .enableDisableDeviceStatusById(this.editDeviceResquestObject)
      .pipe(takeUntil(this.ResponseVerifiedChangeDeviceStatus$))
      .subscribe(
        async data => {
          if (data.status) {
            this.editDeviceResquestObject = {};
            if (deviceStatus === '1') {
              this.devices[index].status = '0';
              this.toastr.success(data.message)
              this.getAllDevices(this.search, this.offset);

            } else {
              this.devices[index].status = '1';
              this.toastr.success(data.message)
              this.getAllDevices(this.search, this.offset);

            }

          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  ngOnDestroy() {
    this.ResponseVerifiedGetAllDevices$.next();
    this.ResponseVerifiedGetAllDevices$.complete();

    this.ResponseVerifiedChangeDeviceStatus$.next();
    this.ResponseVerifiedChangeDeviceStatus$.complete();
  }
}
